import { Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EChartsOption } from 'echarts';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IncidentTimelineGrpah } from 'src/app/models/incident';

@Component({
  selector: 'app-incident-timline-graph',
  templateUrl: './incident-timline-graph.component.html',
  styleUrl: './incident-timline-graph.component.scss',
})
export class IncidentTimlineGraphComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set chartData(val: IncidentTimelineGrpah[]) {
    if (val) {
      this.charData = val;
      if (this.isSet) {
        this.setChartData(this.charData);
      }
    }
  }
  @Input() set screenSize(val: ScreenType) {
    if (val) {
      this.screen = val;
      this.setChartData(this.charData);
      this.isSet = true;
    }
  }
  isSet = false;
  height = '300px';
  screen: ScreenType;
  charData: IncidentTimelineGrpah[];
  ScreenType = ScreenType;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentTimelineGrpah[]
  ) {}
  chartOption: EChartsOption;
  // setChartData(val: IncidentTimelineGrpah[]) {
  //   const statuses = [
  //     'Open',
  //     'Close',
  //     'Verified',
  //     'Snoozed',
  //     'In-Progress',
  //     'On-Hold',
  //     'Approved',
  //     'Rejected',
  //   ];
  //   const statusColors = [
  //     '#FF5733',
  //     '#33FF57',
  //     '#3357FF',
  //     '#FF33A1',
  //     '#33FFF3',
  //     '#F3FF33',
  //     '#F333FF',
  //     '#FFBF33',
  //   ];

  //   // Prepare series data for each status
  //   const series: echarts.EChartsOption['series'] = statuses.map(
  //     (status, index) => {
  //       const statusData = val.filter((item) => item.status === index);

  //       return {
  //         name: status,
  //         type: 'line',
  //         data: statusData.map((item) => ({
  //           value: [new Date(item.eventDate).toISOString(), item.eventTime],
  //           name: new Date(item.eventDate).toISOString(),
  //         })),
  //         symbol: 'circle',
  //         symbolSize: 10,
  //         lineStyle: {
  //           color: statusColors[index],
  //           width: 2,
  //           type: 'solid',
  //         },
  //         itemStyle: {
  //           color: statusColors[index],
  //           borderWidth: 1,
  //           borderColor: '#000000',
  //         },
  //       } as echarts.SeriesOption;
  //     }
  //   );
  //   // Prepare x-axis data as formatted strings from the eventDate
  //   const dates = val.map((item) => new Date(item.eventDate).toISOString());

  //   this.chartOption = {
  //     xAxis: {
  //       type: 'category',
  //       data: dates,
  //       axisLabel: {
  //         rotate: this.screen === ScreenType.Mobile ? 45 : 0,
  //         formatter: (value: string) => {
  //           const date = new Date(value);
  //           return `${date.getDate()}-${
  //             date.getMonth() + 1
  //           }-${date.getFullYear()}`;
  //         },
  //       },
  //     },
  //     yAxis: {
  //       type: 'value',
  //       min: 0,
  //       max: 24,
  //       axisLabel: {
  //         rotate: this.screen === ScreenType.Mobile ? 45 : 0,
  //         formatter: (value: number) => {
  //           const hours = Math.floor(value);
  //           const minutes = Math.floor((value - hours) * 60);
  //           return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  //         },
  //       },
  //     },
  //     grid: {
  //       top: 80,
  //       bottom: 60,
  //       left: 60,
  //       right: 40,
  //     },
  //     legend: {
  //       data: statuses,
  //       top: 10,
  //       left: 'center',
  //       orient: 'horizontal',
  //       textStyle: {
  //         fontSize: this.screen === ScreenType.Mobile ? 8 : 12,
  //         color: '#333',
  //       },
  //     },
  //     series: series,
  //   };
  // }
  // Calculate the chart width based on number of data points
  getChartWidth(): string {
    if (!this.charData || this.charData.length <= 5) {
      return '100%'; // Default width if data is small
    }

    // Calculate a width that ensures each data point has enough space
    // Minimum width of 100px per data point
    const minWidth = Math.max(this.charData.length * 100, 800);
    return `${minWidth}px`;
  }
  setChartData(val: IncidentTimelineGrpah[]) {
    const statuses = [
      'Open',
      'Close',
      'Verified',
      'Snoozed',
      'In-Progress',
      'On-Hold',
      'Approved',
      'Rejected',
    ];

    const statusColors = [
      '#FF5733', // Open - Red-Orange
      '#33FF57', // Close - Green
      '#3357FF', // Verified - Blue
      '#FF33A1', // Snoozed - Pink
      '#33FFF3', // In-Progress - Cyan
      '#F3FF33', // On-Hold - Yellow
      '#F333FF', // Approved - Magenta
      '#FFBF33', // Rejected - Amber
    ];

    // Prepare series data
    const seriesData = val.map((item) => ({
      dateTime: new Date(item.eventDate).toISOString(),
      eventTime: item.eventTime,
      status: item.status,
    }));

    // Set chart options
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const param = params[0];
          return `Date: ${param.value[0]}<br/> Time: ${
            param.value[1]
          }<br/> Status: ${statuses[param.value[2]]}`;
        },
      },
      // legend: {
      //   show: true,
      //   data: statuses,
      //   top: 10,
      //   left: 'center',
      //   orient: 'horizontal',
      //   textStyle: {
      //     fontSize: this.screen === ScreenType.Mobile ? 8 : 12,
      //     color: '#333',
      //   },
      // },
      xAxis: {
        type: 'category',
        data: seriesData.map((item) => item.dateTime),
        axisLabel: {
          rotate: this.screen === ScreenType.Mobile ? 45 : 0,
          formatter: (value: string) => {
            const date = new Date(value);
            return `${date.getDate()}-${
              date.getMonth() + 1
            }-${date.getFullYear()}`;
          },
        },
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 24,
        axisLabel: {
          rotate: this.screen === ScreenType.Mobile ? 45 : 0,
          formatter: (value: number) => {
            const hours = Math.floor(value);
            const minutes = Math.floor((value - hours) * 60);
            return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
          },
        },
      },
      grid: {
        top: 80,
        bottom: 60,
        left: 60,
        right: 40,
      },
      series: [
        {
          type: 'line',
          data: seriesData.map((item) => [
            item.dateTime,
            item.eventTime,
            item.status,
          ]),
          lineStyle: {
            color: '#000', // Keep the line color neutral
            width: 2,
          },
          itemStyle: {
            color: (params: any) => statusColors[params.value[2]], // Color each point according to its status
          },
          markPoint: {
            data: seriesData.map((item) => ({
              name: statuses[item.status],
              coord: [item.dateTime, item.eventTime],
              value: statuses[item.status],
              itemStyle: {
                color: statusColors[item.status],
              },
            })),
          },
          symbol: 'circle',
          symbolSize: 10,
        },
      ],
    };
  }
}
